import { AppState } from '@app/react/reducer';
import { ORDER_PARTS } from '@app/react/const/variables';

export const selectOrderPartsHelp = (
    state: AppState,
): typeof ORDER_PARTS[number] | null => (
    state.uiOrderPartsHelp.opened
);
